export enum AcquisitionStatus {
  UNSET,
  PROSPECTIVE,
  UNDER_CONTRACT,
  OWNED,
}
